import type { SupportedLanguage } from '@/features/i18n';

import './BrandLogo.css';

interface BrandLogoProps {
  language: SupportedLanguage;
  decorative?: boolean;
  size?: 'default' | 'large';
}

export default function BrandLogo({
  language,
  decorative = false,
  size = 'default',
}: BrandLogoProps) {
  const isKorean = language === 'ko';

  return (
    <span
      className={`brand-logo brand-logo--${isKorean ? 'ko' : 'international'}${size === 'large' ? ' brand-logo--large' : ''}`}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : isKorean ? '지음' : 'Jeeum'}
      aria-hidden={decorative ? true : undefined}
    >
      {isKorean ? (
        <img
          className="brand-logo-wordmark"
          src="/img/brand-wordmark.svg"
          width="218"
          height="130"
          alt=""
          aria-hidden="true"
        />
      ) : (
        <>
          <img
            className="brand-logo-symbol"
            src="/img/brand-symbol.svg"
            width="128"
            height="128"
            alt=""
            aria-hidden="true"
          />
          <span className="brand-logo-roman">Jeeum</span>
        </>
      )}
    </span>
  );
}
